import { Button, InputField, InputToggle } from "@jds/core";
import useInput from "../../../hooks/use-input";
import { validateTextInput } from "../../../util/validation";
import { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";

const TextInputForm = ({
  editData,
  closeModal,
  onSuccess,
  setEditData,
  editSuccess,
}) => {
  const [required, setReqired] = useState(false);
  const {
    value: questionName,
    isValid: isValidQuestion,
    hasError: questionError,
    valueChangeHandler: questionChangeHandler,
    inputBlurHandler: questionBlurHandler,
    reset: resetquestion,
  } = useInput(validateTextInput, {
    type: "text",
    value: editData?.questionName,
  });

  const isValidForm = !isValidQuestion;

  const handleSubmit = () => {
    closeModal();
    if (editData) {
      editSuccess(
        {
          id: uuidv4(),
          type: "text",
          questionName: questionName,
          required: required,
        },
        editData.index
      );
    } else {
      onSuccess({
        id: uuidv4(),
        type: "text",
        questionName: questionName,
        required: required,
      });
    }
  };

  useEffect(() => {
    setReqired(editData?.required || false);
    return () => {
      setEditData(null);
    };
  }, []);
  return (
    <div className="column-form full-width">
      <InputField
        label="Question"
        value={questionName}
        name="Question"
        onChange={questionChangeHandler}
        onBlur={questionBlurHandler}
        state={questionError ? "error" : ""}
        stateText="Question  is invalid"
      />
      <InputToggle
        type="toggle"
        label="Required"
        name="reqired"
        size="small"
        checked={required}
        onChange={(e) => {
          setReqired(e.target.checked);
        }}
      ></InputToggle>
      <Button
        fullWidth
        disabled={isValidForm}
        type="submit"
        label="Add"
        size="large"
        onClick={handleSubmit}
      />
    </div>
  );
};

export default TextInputForm;
